import React, { useEffect, useState, useRef } from "react";
import api from "app/api";
import { Buffer } from "buffer";
import { CircularProgress } from "@mui/material";

const AuthorizedImage = ({ path, width, height, zoomLevel, onClick }) => {
  const [imageData, setImageData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [isDragging, setIsDragging] = useState(false);
  const [startPoint, setStartPoint] = useState({ x: 0, y: 0 });
  const imgRef = useRef(null);

  const onMouseDown = (e) => {
    setIsDragging(true);
    setStartPoint({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;
    const x = e.clientX - startPoint.x;
    const y = e.clientY - startPoint.y;
    setPosition({ x, y });
  };

  const onMouseUp = () => {
    setIsDragging(false);
  };

  const onMouseLeave = () => {
    setIsDragging(false);
  };
  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await api.get(`/serviceapi/writeImageToClient?location=${path}`);
        if (response && response?.data) {
          setIsLoading(false);
          setImageData(response?.data?.url || null);
        }
      } catch (error) {
        console.error("Error fetching image:", error);
        setImageData(null);
        setIsLoading(false);
      }
    };
    console.log(path);

    fetchImage();
  }, [path]);

  const isModalView = !width && !height;
  const imageStyle = {
    width: width || null,
    height: height || null,
    maxWidth: "100%",
    maxHeight: "100%",
    minWidth: isModalView ? undefined : 70,
    minHeight: isModalView ? undefined : 70,
    ...(isModalView && { objectFit: "contain" }),
  };
  if (isLoading)
    return (
      <div
        style={{
          textAlign: "center",
          paddingTop: 50,
          paddingBottom: 50,
        }}
      >
        <CircularProgress color="secondary" />
      </div>
    );
  return imageData ? (
    <div
      style={{
        textAlign: "center",
        userSelect: "none",
        ...(isModalView && { width: "100%", height: "100%", minHeight: 0, display: "flex", justifyContent: "center", alignItems: "center" }),
      }}
      onMouseMove={onMouseMove}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
    >
      <div
        style={{
          display: "inline-block",
          overflow: isModalView ? "visible" : "hidden",
          cursor: isDragging ? "grabbing" : "grab",
          ...(isModalView && { width: "100%", height: "100%", maxWidth: "100%", maxHeight: "100%", minHeight: 0, display: "flex", justifyContent: "center", alignItems: "center" }),
        }}
        onMouseDown={onMouseDown}
      >
        {isModalView ? (
          <div
            style={{
              width: `${(zoomLevel ?? 1) * 100}%`,
              height: `${(zoomLevel ?? 1) * 100}%`,
              transform: `translate(${position.x}px, ${position.y}px)`,
              transition: isDragging ? "none" : "transform 0.2s ease-in-out",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              minWidth: "100%",
              minHeight: "100%",
            }}
          >
            <img
              src={imageData}
              alt=""
              ref={imgRef}
              style={{
                ...imageStyle,
                width: "100%",
                height: "100%",
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
              draggable={false}
              onClick={onClick}
            />
          </div>
        ) : (
          <img
            src={imageData}
            alt=""
            ref={imgRef}
            style={{
              ...imageStyle,
              transform: `scale(${zoomLevel ?? 1}) translate(${position.x}px, ${position.y}px)`,
              transition: isDragging ? "none" : "transform 0.2s ease-in-out",
            }}
            draggable={false}
            onClick={onClick}
          />
        )}
      </div>
    </div>
  ) : null;
};

export default AuthorizedImage;
